module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0090.jpg?v=d0a1223e";